<template>
  <div>
    <!-- ── Top info bar ─────────────────────────────────────────────── -->
    <div class="top-bar bg-primary">
      <v-container class="py-1">
        <div class="d-flex justify-space-between align-center">
          <div class="top-bar-links">
            <span><v-icon size="14" class="mr-1">mdi-phone</v-icon>07464-250023</span>
            <span class="ml-4 d-none d-sm-inline">
              <v-icon size="14" class="mr-1">mdi-email-outline</v-icon>gckarauli@gmail.com
            </span>
          </div>
          <div>
            <v-btn
              icon size="x-small" variant="text" color="white"
              href="https://www.facebook.com/Karauli.college/" target="_blank"
            >
              <v-icon size="18">mdi-facebook</v-icon>
            </v-btn>
          </div>
        </div>
      </v-container>
    </div>

    <!-- ── Main header ────────────────────────────────────────────────── -->
    <div class="main-header elevation-2">
      <v-container class="py-2">
        <div class="d-flex align-center">
          <router-link to="/" class="logo-link">
            <v-img src="../assets/gckLogo1.png" height="70" width="70" contain />
          </router-link>
          <div class="ml-3 ml-sm-4">
            <div class="college-name-hi">राजकीय महाविद्यालय करौली</div>
            <div class="college-name-en">Government College Karauli</div>
            <div class="college-sub d-none d-sm-block">Affiliated to University of Kota &nbsp;|&nbsp; Est. 1960</div>
          </div>
          <!-- Mobile hamburger aligned right -->
          <v-spacer />
          <v-app-bar-nav-icon
            class="d-flex d-md-none nav-hamburger"
            @click="drawer = true"
          />
        </div>
      </v-container>
    </div>

    <!-- ── Desktop nav bar ───────────────────────────────────────────── -->
    <div class="desktop-nav d-none d-md-flex">
      <v-container>
        <div class="d-flex align-center flex-wrap">
          <v-btn to="/" variant="text" color="white" class="nav-btn">
            <v-icon size="16" class="mr-1">mdi-home</v-icon>Home
          </v-btn>

          <template v-for="menu in allMenus" :key="menu.id ?? menu.key">
            <!-- has children → dropdown -->
            <v-menu
              v-if="menu.children && menu.children.length"
              open-on-hover
              :close-on-content-click="true"
              location="bottom"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text" color="white"
                  class="nav-btn"
                  :append-icon="'mdi-chevron-down'"
                >{{ menu.title }}</v-btn>
              </template>
              <v-list density="compact" class="nav-dropdown" min-width="220">
                <v-list-item
                  v-for="child in menu.children"
                  :key="child.id ?? child.key"
                  class="nav-dropdown-item"
                  @click="navigate(child)"
                >
                  <v-list-item-title class="text-body-2">{{ child.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- no children → direct link -->
            <v-btn
              v-else
              variant="text" color="white"
              class="nav-btn"
              @click="navigate(menu)"
            >{{ menu.title }}</v-btn>
          </template>

          <v-btn to="/contact" variant="text" color="white" class="nav-btn">Contact</v-btn>
        </div>
      </v-container>
    </div>

    <!-- ── Mobile drawer ─────────────────────────────────────────────── -->
    <v-navigation-drawer v-model="drawer" temporary width="300">
      <div class="drawer-header bg-primary pa-4">
        <v-img src="../assets/gckLogo1.png" height="50" width="50" contain class="mb-2" />
        <div style="color:#fff; font-weight:700; font-size:0.95rem;">Govt. College Karauli</div>
      </div>

      <v-list density="compact" nav>
        <v-list-item to="/" prepend-icon="mdi-home" title="Home" />

        <template v-for="menu in allMenus" :key="menu.id ?? menu.key">
          <v-list-group v-if="menu.children && menu.children.length" :value="menu.key">
            <template #activator="{ props }">
              <v-list-item v-bind="props" :title="menu.title" />
            </template>
            <v-list-item
              v-for="child in menu.children"
              :key="child.id ?? child.key"
              :title="child.title"
              class="pl-6"
              @click="navigate(child); drawer = false"
            />
          </v-list-group>

          <v-list-item
            v-else
            :title="menu.title"
            @click="navigate(menu); drawer = false"
          />
        </template>

        <v-list-item to="/contact" prepend-icon="mdi-phone" title="Contact Us" />
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'AppBar',
  data () {
    return { drawer: false }
  },
  computed: {
    allMenus () {
      return this.$store.state.menus
    },
  },
  methods: {
    navigate (item) {
      if (item.full_url) {
        window.open(item.path, '_blank')
      } else {
        this.$router.push(item.path)
      }
    },
  },
}
</script>

<style scoped>
/* ── Top bar ─────────────────────────────────────────── */
.top-bar { font-size: 0.78rem; color: rgba(255,255,255,0.9); }

/* ── Main header ─────────────────────────────────────── */
.main-header {
  background: #fff;
  border-bottom: 3px solid #1A237E;
}

.logo-link { display: flex; align-items: center; text-decoration: none; flex-shrink: 0; }

.college-name-hi {
  font-size: clamp(0.95rem, 2.5vw, 1.35rem);
  font-weight: 700;
  color: #1A237E;
  line-height: 1.2;
}
.college-name-en {
  font-size: clamp(0.8rem, 2vw, 1.1rem);
  font-weight: 600;
  color: #F57C00;
  line-height: 1.2;
}
.college-sub { font-size: 0.72rem; color: #607D8B; margin-top: 2px; }

.nav-hamburger { color: #1A237E !important; }

/* ── Desktop nav ─────────────────────────────────────── */
.desktop-nav {
  background: #1A237E;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 12px rgba(26,35,126,0.4);
}

.nav-btn {
  font-size: 0.78rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
  padding: 0 10px !important;
  height: 46px !important;
  text-transform: none !important;
  border-radius: 0 !important;
  transition: background 0.2s;
}
.nav-btn:hover { background: rgba(255,255,255,0.08) !important; }

/* ── Dropdown ────────────────────────────────────────── */
.nav-dropdown { background: #fff; border-top: 3px solid #1A237E; }

.nav-dropdown-item { cursor: pointer; transition: background 0.15s; }
.nav-dropdown-item:hover { background: #F4F7FF; color: #1A237E; }

/* ── Drawer header ───────────────────────────────────── */
.drawer-header { background: #1A237E; }
</style>
